import API2 from 'api/services/v2'
import clsx from 'clsx'
import { WideLayout } from 'layouts'
import omit from 'lodash/omit'
import AdvertiserInfoEditForm from 'modules/Forms/Advertisers/Edit'
import formStyles from 'modules/Forms/common-form.module.scss'
import styles from 'modules/Services/AccountCreate/account-register.module.scss'
import React, { useEffect, useState } from 'react'
import { useHistory, useRouteMatch } from 'react-router'
import validator from 'utils/asyncValidator'
import advertiserInfoValidationRulesExtended from 'modules/Forms/Account/Create/subcomponents/advertiser-info-validation-rules-extended'
import { ROUTES } from 'constants/routes'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import GridSpinner from 'components/UI/GridSpinner'
import { useNetworksData } from 'modules/Services/hooks/useNetworksData'

export function isObject(item) {
  return item && typeof item === 'object' && !Array.isArray(item)
}

export function mergeDeepButNull(target, ...sources) {
  if (!sources.length) {
    return target
  }

  const source = sources.shift()

  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (source[key] === null) {
        Object.assign(target, { [key]: target[key] })
      } else {
        if (isObject(source[key])) {
          if (!target[key]) Object.assign(target, { [key]: {} })
          mergeDeepButNull(target[key], source[key])
        } else {
          Object.assign(target, { [key]: source[key] })
        }
      }
    }
  }

  return mergeDeepButNull(target, ...sources)
}

const INITIAL_VALUES = {
  payment_profile_id: undefined,
  advertiser_info: {
    type: '',
    tax_number: '',
    phone: '',
    name: '',
    contract: {
      number: '',
      date: '',
      type: '',
      amount: null,
      subject_type: '',
      action_type: '',
    },
    counterparty: {
      type: '',
      name: '',
      tax_number: '',
      phone: '',
    },
  },
}

const validationSchema = (networkType) => advertiserInfoValidationRulesExtended(networkType)

const AccountAdvertiserInfoEdit = () => {
  const {
    params: { i18n, networkType, accountId },
  } = useRouteMatch()
  const pathGen = useGeneratePathI18n()
  const history = useHistory()
  const [loading, setLoading] = useState(true)
  const [initialValues, setInitialValues] = useState(null)
  const [login, setAccountLogin] = useState(null)
  const [advertiserInfoErrors, setAdvertiserInfoErrors] = useState([])
  const { networkId } = useNetworksData(networkType)

  useEffect(() => {
    if (!accountId) return

    API2.getNetworkAccountById({ accountId })
      .then(({ response, error }) => {
        if (error) {
          history.push(
            pathGen(ROUTES.SERVICES_NETWORK_ACCOUNT, {
              networkType,
              accountId,
            }),
          )
        }

        if (!error) {
          setAccountLogin(response?.data?.login)
          setInitialValues(
            mergeDeepButNull(INITIAL_VALUES, {
              advertiser_info: omit(response?.data?.advertiser_info, ['errors']),
            }),
          )

          if (response?.data?.errors) {
            setAdvertiserInfoErrors(response?.data?.errors)
          }
        }
      })
      .finally(() => setLoading(false))
  }, [accountId])

  return (
    <WideLayout
      onClose={(e) => {
        e.preventDefault()
        history.push(
          pathGen(ROUTES.SERVICES_NETWORK_ACCOUNT, {
            networkType,
            accountId,
          }),
        )
      }}
    >
      <div className={formStyles['formContainer']}>
        <div className={clsx(formStyles['formContainer__inner'], styles['inner-container'])}>
          {loading ? (
            <GridSpinner />
          ) : (
            networkType && (
              <AdvertiserInfoEditForm
                onClose={() =>
                  history.push(
                    pathGen(ROUTES.SERVICES_NETWORK_ACCOUNT, {
                      networkType,
                      accountId,
                    }),
                  )
                }
                networkType={networkType}
                networkId={networkId}
                accountId={accountId}
                initialValues={initialValues}
                accountLogin={login}
                i18n={i18n}
                asyncValidate={validator(validationSchema(networkType))}
                advertiser_info_errors={advertiserInfoErrors}
              />
            )
          )}
        </div>
      </div>
    </WideLayout>
  )
}

export default AccountAdvertiserInfoEdit
